import { Component, OnInit } from '@angular/core';
import { DataService } from '../../shared/dataservice.service';
import { KPIChartService } from '../../shared/kpi-charts-service';
import { SalesOrder,  SubSalesOrder,ElectricalDesignEngineer, MechanicalDesignEngineerKPI,FunctionStatus, SOStatus, SSOStatus, monthFilter, MarketingEngineer, userFilterOption, UiWaitReadySO, CommentsPR, PmTechnicalIP, Equipment,ElectricalDesignEngineerKPI, MechanicalDesignEngineer, ProjectEngineer, ProjectEngineerKPI, yearFilter } from '../../shared/misc-classes';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-kpis-v4',
  templateUrl: './kpis-v4.component.html',
  styleUrls: ['./kpis-v4.component.css']
})
export class KpisV4Component implements OnInit {

  _soObjList2: Array<SalesOrder>;

  ElecDesignEngg= '';
  ElecDesignEnggArray:string[]= [];
  MechDesignEngg= '';
  MechanicalDesignEnggArray:string[]= [];
  ProjectEngg= '';
  ProjectEnggArray:string[]= [];

  ElectricalDesignEngineerKPIArray:Array<ElectricalDesignEngineerKPI> = [];
  MechanicalDesignEngineerKPIArray:Array<MechanicalDesignEngineerKPI> = [];
  ProjectEngineerKPIArray:Array<ProjectEngineerKPI> = [];
  isUserSelectionFilterSelected:boolean = false;
  isMechUserSelectionFilterSelected:boolean = false;
  isPEUserSelectionFilterSelected:boolean = false;
  userSelectionType:userFilterOption = userFilterOption.All;
  userMechSelectionType:userFilterOption = userFilterOption.All;
  userPESelectionType:userFilterOption = userFilterOption.All;
  Highcharts = Highcharts;

  isLoading: boolean = false;
  isLoading2:boolean = false;
  isDataViewUpdated: boolean = false;

  totalDataSld: any;
  totalDataMDE: any;
  totalDataPE: any;
  totalDataSldKpiChartOptionsSO: Highcharts.Options;
  totalDataMDEKpiChartOptionsSO: Highcharts.Options;
  totalDataPEKpiChartOptionsSO: Highcharts.Options;

  MechanicalEngineers:any=[];

  isYearFilterSelectedPE:boolean = false;
  yearFilterPE:yearFilter;

  isYearFilterSelectedMDE:boolean = false;
  yearFilterMDE:yearFilter;

  isYearFilterSelectedEDE:boolean = false;
  yearFilterEDE:yearFilter;

  constructor(public _dataService: DataService,private _kpiCharServ: KPIChartService) { }

  ngOnInit() {
    this._dataService.currPageName = 'Individual KPI 1';
    let name = [];
    let meId = [];

    this._dataService.mechanicalDesignEngineers.forEach(e => {
      name.push(e.mechanicalDesignEngineerName);
      meId.push(e.mechanicalDesignEngineerId);
    });
    this._dataService.c30Engineer.forEach(e => {
      name.push(e.c30EngineerName);
      meId.push(e.c30EngineerId);
    });

    for (var i = 0; i < name.length; i++) {
      this.MechanicalEngineers.push({ name: name[i], id: meId[i] });
    }
    
    try{
      this.loadSettingsFromCookies();
    }catch(e){
      console.log(e);
    }
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    this._dataService.getDataDefinitions().subscribe(res => {
      this._dataService.getAllSalesOrder_2(0).subscribe((_soObjAr2:Array<SalesOrder>) => {
        this._soObjList2 = _soObjAr2;
        // console.log(this._soObjList2)
        this.loadEDEData();
        this.filterRows();

        this.loadMDEData();
        this.filterRowsMech();
        
        this.filterRowsPE();
        this.loadPEData();
      });
    });
  }

  filterRows1(_event){
    this.ElecDesignEngg = _event.value;
    this.userSelectionType = userFilterOption.ElectricDesignEngineer;
    this.ElecDesignEnggArray = _event.value;
    if(this.ElecDesignEngg == null || this.ElecDesignEngg == ""){
      this.isUserSelectionFilterSelected = false;
    }else{
      this.isUserSelectionFilterSelected = true;
    }
    this.filterRows();
  }

  filterRows2(_event){
    this.MechDesignEngg = _event.value;
    this.userMechSelectionType = userFilterOption.MechanicalDesignEngineer;
    this.MechanicalDesignEnggArray = _event.value;
    if(this.MechDesignEngg == null || this.MechDesignEngg == ""){
      this.isMechUserSelectionFilterSelected = false;
    }else{
      this.isMechUserSelectionFilterSelected = true;
    }
    this.filterRowsMech();
    
  }

  filterRows3(_event){
    this.ProjectEngg = _event.value;
    this.userPESelectionType = userFilterOption.ProjectEngineer;
    this.ProjectEnggArray = _event.value;
    if(this.ProjectEngg == null || this.ProjectEngg == ""){
      this.isPEUserSelectionFilterSelected = false;
    }else{
      this.isPEUserSelectionFilterSelected = true;
    }
    this.filterRowsPE();
    
  }

  filterRows(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic2();
      this.loadEDEData();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }

  filterRowsMech(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic3();
      this.loadMDEData();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }

  filterRowsPE(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic4();
      this.loadPEData();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }

  saveSettingsToCookies() {
    this._dataService.setCookie('s-elecDesignEngg-indv-kpi-1', this.isUserSelectionFilterSelected ? "1":"0");
        if(this.isUserSelectionFilterSelected){
          this._dataService.setCookie('s-elecDesignEngg-indv-kpi-1', this.ElecDesignEnggArray + '');
        }

        this._dataService.setCookie('s-mdeDesignEngg-indv-kpi-1', this.isMechUserSelectionFilterSelected ? "1":"0");
        if(this.isMechUserSelectionFilterSelected){
          this._dataService.setCookie('s-mdeDesignEngg-indv-kpi-1', this.MechanicalDesignEnggArray + '');
        }

        this._dataService.setCookie('s-peDesignEngg-indv-kpi-1', this.isPEUserSelectionFilterSelected ? "1":"0");
        if(this.isPEUserSelectionFilterSelected){
          this._dataService.setCookie('s-peDesignEngg-indv-kpi-1', this.ProjectEnggArray + '');
        }
        this._dataService.setCookie('s-year-sel-pe', this.isYearFilterSelectedPE ? "1":"0");
        if (this.isYearFilterSelectedPE) {
          this._dataService.setCookie('s-year-val-pe', this.yearFilterPE.getCookieStr());
        }
        this._dataService.setCookie('s-year-sel-ede', this.isYearFilterSelectedEDE ? "1":"0");
        if (this.isYearFilterSelectedEDE) {
          this._dataService.setCookie('s-year-val-ede', this.yearFilterEDE.getCookieStr());
        }
        this._dataService.setCookie('s-year-sel-mde', this.isYearFilterSelectedMDE ? "1":"0");
        if (this.isYearFilterSelectedMDE) {
          this._dataService.setCookie('s-year-val-mde', this.yearFilterMDE.getCookieStr());
        }
    
  }

  loadSettingsFromCookies(){

    let _tmpElecDesignEngg = this._dataService.getCookie('s-elecDesignEngg-indv-kpi-1');
    
    if(_tmpElecDesignEngg != "0" && _tmpElecDesignEngg != ""){
      this.ElecDesignEngg = _tmpElecDesignEngg;
      this.ElecDesignEnggArray = _tmpElecDesignEngg.split(",");
      this.isUserSelectionFilterSelected = true;
      this.userSelectionType = userFilterOption.ElectricDesignEngineer;
    }else{
      this.isUserSelectionFilterSelected = false;
      this.userSelectionType = userFilterOption.All;
    }

    let _tmpMechDesignEngg = this._dataService.getCookie('s-mdeDesignEngg-indv-kpi-1');

    if(_tmpMechDesignEngg != "0" && _tmpMechDesignEngg != ""){
      this.MechDesignEngg = _tmpMechDesignEngg;
      this.MechanicalDesignEnggArray = _tmpMechDesignEngg.split(",");
      this.isMechUserSelectionFilterSelected = true;
      this.userMechSelectionType = userFilterOption.MechanicalDesignEngineer;
    }else{
      this.isMechUserSelectionFilterSelected = false;
      this.userMechSelectionType = userFilterOption.All;
    }
    
    let _tmpPEDesignEngg = this._dataService.getCookie('s-peDesignEngg-indv-kpi-1');
  
    if(_tmpPEDesignEngg != "0" && _tmpPEDesignEngg != ""){
      this.ProjectEngg = _tmpPEDesignEngg;
      this.ProjectEnggArray = _tmpPEDesignEngg.split(",");
      this.isPEUserSelectionFilterSelected = true;
      this.userPESelectionType = userFilterOption.ProjectEngineer;
    }else{
      this.isPEUserSelectionFilterSelected = false;
      this.userPESelectionType = userFilterOption.All;
    }

    let _tmpYearSel:string = this._dataService.getCookie('s-year-sel-pe');
    if(_tmpYearSel){
      this.isYearFilterSelectedPE = (_tmpYearSel == "1");

      let _tmpYearVal:string = this._dataService.getCookie('s-year-val-pe');
      if(_tmpYearVal){        
        this.yearFilterPE = yearFilter.getObjFromCookieStr(_tmpYearVal);
      }
    }
    let _tmpYearSelEDE:string = this._dataService.getCookie('s-year-sel-ede');
    if(_tmpYearSelEDE){
      this.isYearFilterSelectedEDE = (_tmpYearSelEDE == "1");

      let _tmpYearValEDE:string = this._dataService.getCookie('s-year-val-ede');
      if(_tmpYearValEDE){        
        this.yearFilterEDE = yearFilter.getObjFromCookieStr(_tmpYearValEDE);
      }
    }
    let _tmpYearSelMDE:string = this._dataService.getCookie('s-year-sel-mde');
    if(_tmpYearSelMDE){
      this.isYearFilterSelectedMDE = (_tmpYearSelMDE == "1");

      let _tmpYearValMDE:string = this._dataService.getCookie('s-year-val-mde');
      if(_tmpYearValMDE){        
        this.yearFilterMDE = yearFilter.getObjFromCookieStr(_tmpYearValMDE);
      }
    }

    let _currDate:Date = new Date();
    if(this.yearFilterPE == null){
      this.yearFilterPE = new yearFilter(_currDate.getFullYear());
    }
    if(this.yearFilterEDE == null){
      this.yearFilterEDE = new yearFilter(_currDate.getFullYear());
    }
    if(this.yearFilterMDE == null){
      this.yearFilterMDE = new yearFilter(_currDate.getFullYear());
    }
  }

  clearElecFilters(){
    this.ElecDesignEngg = "";
    this.userSelectionType = userFilterOption.All;
    this.ElecDesignEnggArray = [];
    this.isUserSelectionFilterSelected = false;
    this.isYearFilterSelectedEDE = false;
    this.saveSettingsToCookies();
    this.filterRows();
  }

  clearMechFilters(){
    this.MechDesignEngg = "";
    this.userMechSelectionType = userFilterOption.All;
    this.MechanicalDesignEnggArray = [];
    this.isMechUserSelectionFilterSelected = false;
    this.isYearFilterSelectedMDE = false;
    this.saveSettingsToCookies();
    this.filterRowsMech();
  }

  clearProjFilters(){
    this.ProjectEngg = "";
    this.userPESelectionType = userFilterOption.All;
    this.ProjectEnggArray = [];
    this.isPEUserSelectionFilterSelected = false;
    this.isYearFilterSelectedPE = false;
    this.saveSettingsToCookies();
    this.filterRowsPE();
  }

  filterRowsLogic2() {

    let _sldCsEle:number= 0;
    let _schemeAndOtherDrgsEle:number=0;
    let _sldGaCsEle:number=0;
    let _C40Ele:number=0;
    let _C60Ele:number=0;


    let _tmpSldCounter: number = 0;
    let _tmpSchematicCounter: number = 0;
    let _tmpSldGaCounter: number = 0;
    let _tmpC40Counter: number = 0;
    let _tmpC60Counter: number = 0;

    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    let _showSOWithNoSSO: boolean = true;
    if(this.isYearFilterSelectedEDE==true){
    for (var i = 0; i < this._soObjList2.length; i++) {
      let _tmpSO: SalesOrder = this._soObjList2[i];

      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        //filters need to be added for user
        let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrders(_tmpSO.subSalesOrder);
        //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

          _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
            let equipmentFlagArray:boolean[] = [];
          
            subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                equipmentFlagArray.push(true);
              }else{
                equipmentFlagArray.push(false);
              }
            });

            if(equipmentFlagArray.includes(true)){
             // _tmpSO.subSalesOrder.forEach((subSaleOrder:SubSalesOrder) => {
                // let currentYear:Date = new Date();
                let selYear:Date = new Date(this.yearFilterEDE.selYear,1,1);
                if(subSaleOrder.enggDrawIP.electricalDesignEngineerId != null && subSaleOrder.enggDrawIP.electricalDesignEngineerId != ""){

                
              // Check for C40 date and SLD date is missing   
              // SLD CS (1st subm) (Actual SLD- Actual HOM)+ 1
              // if ((subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null && currentYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() )) {
              if ((subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null && selYear.getFullYear() == subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getFullYear() )&& _tmpSO.marketingIP.actualHandingOverDate != null) {
                _tmpSldCounter++;
                let _actualSLDSubmission = subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getTime();
                let _actualHandingOverDate = _tmpSO.marketingIP.actualHandingOverDate.getTime();
                let diffDates = (_actualSLDSubmission - _actualHandingOverDate);
                let _sldDiff_time = diffDates / (1000 * 3600 * 24);
                let _sldDiff = _sldDiff_time + 1;
                _sldCsEle +=_sldDiff;
              }

              // Check for C40 date and Scheme date is missing
              // Schemes & other drgs  (Actual Schem- Actual HOM)+ 1

              // if ((subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null && currentYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() )) {
              if ((subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual != null && selYear.getFullYear() == subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual.getFullYear() )&& _tmpSO.marketingIP.actualHandingOverDate != null) {
                _tmpSchematicCounter++;
                let _actualSchematicBOMSubmission = subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual.getTime();
                let _actualHandingOverDate = _tmpSO.marketingIP.actualHandingOverDate.getTime();
                let diffDatesSchematicAndOtherDrgs = (_actualSchematicBOMSubmission - _actualHandingOverDate);
                let _schematicDiff_time = diffDatesSchematicAndOtherDrgs / (1000 * 3600 * 24);
                let _schematicDiff = _schematicDiff_time + 1;
                _schemeAndOtherDrgsEle +=_schematicDiff;
              }

              // Check for C40 date and Approval date is missing
              // Approval (SLD+GA+CS) (Actual SLD & GA approval- Actual SLD)+ 1

              // if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )&& (subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getFullYear() )) {
              if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && selYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )&& subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null) {
                _tmpSldGaCounter++;
                let _actualSLDGAApprovalDate = subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getTime();
                let _initialSLDSubmissionDateActual = subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getTime();
                let diffDatesSLDAndGA = (_actualSLDGAApprovalDate - _initialSLDSubmissionDateActual);
                let _SldAndGaDiff_time = diffDatesSLDAndGA / (1000 * 3600 * 24);
                let _SldAndGaDiff = _SldAndGaDiff_time + 1;
                _sldGaCsEle +=_SldAndGaDiff;
              }

              // Check for actual line loading and C40 date actual missing
              // C40 --- Actual C40- Actual SLD & GA approval
              
              // if ((subSaleOrder.enggDrawIP.electricalDesignEngineerId != null && subSaleOrder.enggDrawIP.electricalDesignEngineerId != "") && (subSaleOrder.enggProcureIP.actualC40Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear() )&& (subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )) {
              if ((subSaleOrder.enggDrawIP.electricalDesignEngineerId != null && subSaleOrder.enggDrawIP.electricalDesignEngineerId != "") &&(subSaleOrder.enggProcureIP.actualC40Date != null && selYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear() )&& subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null) {
                
                _tmpC40Counter++;
                let _actualC40Date = subSaleOrder.enggProcureIP.actualC40Date.getTime();
                let _actualSLDGAApprovalDate = subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getTime();
                let diffDatesC40AndSLDAndGA = (_actualC40Date - _actualSLDGAApprovalDate);
                let _C40SldAndGaDiff_time = diffDatesC40AndSLDAndGA / (1000 * 3600 * 24);
                let _C40SldAndGaDiff = _C40SldAndGaDiff_time + 1;
                _C40Ele +=_C40SldAndGaDiff;
              }

              // Check for actual line loading and C60 date actual missing
              // C60 --- Actual C60- Actual C40

              // if ((subSaleOrder.enggProcureIP.actualC60Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC60Date.getFullYear())&& (subSaleOrder.enggProcureIP.actualC40Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear() )) {
              if ((subSaleOrder.enggProcureIP.actualC60Date != null && selYear.getFullYear() == subSaleOrder.enggProcureIP.actualC60Date.getFullYear())&& subSaleOrder.enggProcureIP.actualC40Date != null) {
                _tmpC60Counter++;
                let _actualC60Date = subSaleOrder.enggProcureIP.actualC60Date.getTime();
                let _actualC40Date = subSaleOrder.enggProcureIP.actualC40Date.getTime();
                let diffDatesC60AndC40 = (_actualC60Date - _actualC40Date);
                let _C60AndC40Diff_time = diffDatesC60AndC40 / (1000 * 3600 * 24);
                let _C40AndC60Diff = _C60AndC40Diff_time + 1;
                _C60Ele +=_C40AndC60Diff;
                
              }
              //});
            }
            }
          });
        }
      }
    }
  }
    else {
      this._soObjList2.filter((_tmpSO:SalesOrder) => {
        //test the filter.
        // if(_tmpSO.projectStatus == SOStatus.Dispatched || _tmpSO.projectStatus == SOStatus.Archived)
        if(_tmpSO.projectStatus == SOStatus.Dispatched)
        {
          return false;
        }
        return true;
      });
      for (var i = 0; i < this._soObjList2.length; i++) {
        let _tmpSO: SalesOrder = this._soObjList2[i];
  
        let _isSOPassedFilter: boolean = true;
        if (_isSOPassedFilter == true) {
          //filters need to be added for user
          let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrders1(_tmpSO.subSalesOrder);
          //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
  
          if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
  
            _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
              let equipmentFlagArray:boolean[] = [];
            
              subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                if (_equpList.includes(e.equipmentType)) {
                  equipmentFlagArray.push(true);
                }else{
                  equipmentFlagArray.push(false);
                }
              });
  
              if(equipmentFlagArray.includes(true)){
               // _tmpSO.subSalesOrder.forEach((subSaleOrder:SubSalesOrder) => {
                  // let currentYear:Date = new Date();
                  if(subSaleOrder.enggDrawIP.electricalDesignEngineerId != null && subSaleOrder.enggDrawIP.electricalDesignEngineerId != ""){
  
                  
                // Check for C40 date and SLD date is missing   
                // SLD CS (1st subm) (Actual SLD- Actual HOM)+ 1
                // if ((subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null && currentYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() )) {
                // if ((subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getFullYear() )&& _tmpSO.marketingIP.actualHandingOverDate != null) {
                  if ((subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null )&& _tmpSO.marketingIP.actualHandingOverDate != null) {
                  _tmpSldCounter++;
                  let _actualSLDSubmission = subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getTime();
                  let _actualHandingOverDate = _tmpSO.marketingIP.actualHandingOverDate.getTime();
                  let diffDates = (_actualSLDSubmission - _actualHandingOverDate);
                  let _sldDiff_time = diffDates / (1000 * 3600 * 24);
                  let _sldDiff = _sldDiff_time + 1;
                  _sldCsEle +=_sldDiff;
                }
  
                // Check for C40 date and Scheme date is missing
                // Schemes & other drgs  (Actual Schem- Actual HOM)+ 1
  
                // if ((subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null && currentYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() )) {
                // if ((subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual.getFullYear() )&& _tmpSO.marketingIP.actualHandingOverDate != null) {
                  if ((subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual != null )&& _tmpSO.marketingIP.actualHandingOverDate != null) {
                  _tmpSchematicCounter++;
                  let _actualSchematicBOMSubmission = subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual.getTime();
                  let _actualHandingOverDate = _tmpSO.marketingIP.actualHandingOverDate.getTime();
                  let diffDatesSchematicAndOtherDrgs = (_actualSchematicBOMSubmission - _actualHandingOverDate);
                  let _schematicDiff_time = diffDatesSchematicAndOtherDrgs / (1000 * 3600 * 24);
                  let _schematicDiff = _schematicDiff_time + 1;
                  _schemeAndOtherDrgsEle +=_schematicDiff;
                }
  
                // Check for C40 date and Approval date is missing
                // Approval (SLD+GA+CS) (Actual SLD & GA approval- Actual SLD)+ 1
  
                // if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )&& (subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getFullYear() )) {
                // if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )&& subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null) {
                  if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null )&& subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null) {
                  _tmpSldGaCounter++;
                  let _actualSLDGAApprovalDate = subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getTime();
                  let _initialSLDSubmissionDateActual = subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getTime();
                  let diffDatesSLDAndGA = (_actualSLDGAApprovalDate - _initialSLDSubmissionDateActual);
                  let _SldAndGaDiff_time = diffDatesSLDAndGA / (1000 * 3600 * 24);
                  let _SldAndGaDiff = _SldAndGaDiff_time + 1;
                  _sldGaCsEle +=_SldAndGaDiff;
                }
  
                // Check for actual line loading and C40 date actual missing
                // C40 --- Actual C40- Actual SLD & GA approval
                
                // if ((subSaleOrder.enggDrawIP.electricalDesignEngineerId != null && subSaleOrder.enggDrawIP.electricalDesignEngineerId != "") && (subSaleOrder.enggProcureIP.actualC40Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear() )&& (subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )) {
                // if ((subSaleOrder.enggDrawIP.electricalDesignEngineerId != null && subSaleOrder.enggDrawIP.electricalDesignEngineerId != "") &&(subSaleOrder.enggProcureIP.actualC40Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear() )&& subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null) {
                  if ((subSaleOrder.enggDrawIP.electricalDesignEngineerId != null && subSaleOrder.enggDrawIP.electricalDesignEngineerId != "") &&(subSaleOrder.enggProcureIP.actualC40Date != null )&& subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null) {
                  
                  _tmpC40Counter++;
                  let _actualC40Date = subSaleOrder.enggProcureIP.actualC40Date.getTime();
                  let _actualSLDGAApprovalDate = subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getTime();
                  let diffDatesC40AndSLDAndGA = (_actualC40Date - _actualSLDGAApprovalDate);
                  let _C40SldAndGaDiff_time = diffDatesC40AndSLDAndGA / (1000 * 3600 * 24);
                  let _C40SldAndGaDiff = _C40SldAndGaDiff_time + 1;
                  _C40Ele +=_C40SldAndGaDiff;
                }
  
                // Check for actual line loading and C60 date actual missing
                // C60 --- Actual C60- Actual C40
  
                // if ((subSaleOrder.enggProcureIP.actualC60Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC60Date.getFullYear())&& (subSaleOrder.enggProcureIP.actualC40Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear() )) {
                // if ((subSaleOrder.enggProcureIP.actualC60Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC60Date.getFullYear())&& subSaleOrder.enggProcureIP.actualC40Date != null) {
                  if ((subSaleOrder.enggProcureIP.actualC60Date != null)&& subSaleOrder.enggProcureIP.actualC40Date != null) {
                  _tmpC60Counter++;
                  let _actualC60Date = subSaleOrder.enggProcureIP.actualC60Date.getTime();
                  let _actualC40Date = subSaleOrder.enggProcureIP.actualC40Date.getTime();
                  let diffDatesC60AndC40 = (_actualC60Date - _actualC40Date);
                  let _C60AndC40Diff_time = diffDatesC60AndC40 / (1000 * 3600 * 24);
                  let _C40AndC60Diff = _C60AndC40Diff_time + 1;
                  _C60Ele +=_C40AndC60Diff;
                  
                }
                //});
              }
              }
            });
          }
        }
      }
    }
    if(_sldCsEle!=0 || _schemeAndOtherDrgsEle!=0 || _sldGaCsEle!=0 || _C40Ele!=0 || _C60Ele!=0){
      this.totalDataSld = [{
        "data": [{
          name: 'SLD CS (1st subm)',
          color: '#6e6e6e',
          y: Math.round(_sldCsEle/_tmpSldCounter),
        },
        {
          name: 'Schemes & other drawings ',
          color: '#6e6e6e',
          y: Math.round(_schemeAndOtherDrgsEle/_tmpSchematicCounter),
        },
        {
          name: 'Approval (SLD+GA+CS)',
          color: '#6e6e6e',
          y: Math.round(_sldGaCsEle/_tmpSldGaCounter),
        },
        {
          name: 'C40',
          color: '#6e6e6e',
          y: Math.round(_C40Ele/_tmpC40Counter),
        },
        {
          name: 'C60',
          color: '#6e6e6e',
          y: Math.round(_C60Ele/_tmpC60Counter),
        }]
      }

      ];
    }
      else { this.totalDataSld= null;}
    


    this.totalDataSldKpiChartOptionsSO = this._kpiCharServ.getTotalDataChartOptions(this.totalDataSld);

    this.isDataViewUpdated = true;
    setTimeout(() => {
      this.isDataViewUpdated = false;
    }, 1000);
  }

  filterRowsLogic3(){
    let _gaAndCrossSectionMech:number= 0;
    let _c50Mech:number=0;
 
    let _tmpgaAndCrossSectionCounter: number = 0;
    let _tmpc50Counter: number = 0;

    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    let _showSOWithNoSSO: boolean = true;
    if(this.isYearFilterSelectedMDE==true){
    for (var i = 0; i < this._soObjList2.length; i++) {
      let _tmpSO: SalesOrder = this._soObjList2[i];

      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        let _filteredSSO: Array<SubSalesOrder> = [];
       
        _filteredSSO = this.getFilteredSubOrdersC30(_tmpSO.subSalesOrder);
        //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

          _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
            let equipmentFlagArray:boolean[] = [];
          
            subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                equipmentFlagArray.push(true);
              }else{
                equipmentFlagArray.push(false);
              }
            });

            if(equipmentFlagArray.includes(true)){
                // let currentYear:Date = new Date();
                let selYear:Date = new Date(this.yearFilterMDE.selYear,1,1);
                if(this.MechDesignEngg == "" || this.MechanicalDesignEnggArray.includes("001")){
                  if(subSaleOrder.enggDrawIP.c30EngineerId != null && subSaleOrder.enggDrawIP.c30EngineerId != "" && subSaleOrder.enggDrawIP.c30EngineerId != "NaN"){
                    // Check for C40 date actual and GA date is missing  
                    // GA & Cross section // (Actual SLD- Actual HOM)+ 1
                    // if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null && currentYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() )) {
                    if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && selYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null)) {
                      _tmpgaAndCrossSectionCounter++;
                      let _actualSLDGASubmission = subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getTime();
                      let _actualHandingOverDate = _tmpSO.marketingIP.actualHandingOverDate.getTime();
                      let diffDates = (_actualSLDGASubmission - _actualHandingOverDate);
                      let _gaAndCrossSecDiff_time = diffDates / (1000 * 3600 * 24);
                      let _gaAndCrossSecDiff = _gaAndCrossSecDiff_time + 1;
                      _gaAndCrossSectionMech +=_gaAndCrossSecDiff;
                    }
                  }
                }
                
            }
          });
        }
      }
    }

    for (var i = 0; i < this._soObjList2.length; i++) {
      let _tmpSOM: SalesOrder = this._soObjList2[i];

      let _isSOPassedFilterM: boolean = true;
      if (_isSOPassedFilterM == true) {
        
        let _filteredSSOM: Array<SubSalesOrder> = [];
        
        _filteredSSOM = this.getFilteredSubOrdersMech(_tmpSOM.subSalesOrder);
        if (_filteredSSOM.length > 0 || (_tmpSOM.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

          _filteredSSOM.forEach((subSaleOrder: SubSalesOrder) => {
            let equipmentFlagArrayM:boolean[] = [];
          
            subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                equipmentFlagArrayM.push(true);
              }else{
                equipmentFlagArrayM.push(false);
              }
            });

            if(equipmentFlagArrayM.includes(true)){
                // let currentYear:Date = new Date();
                let selYear:Date = new Date(this.yearFilterMDE.selYear,1,1);
                //if((this.MechanicalDesignEnggArray.length == 1 && this.MechDesignEngg != "001") || (this.MechDesignEngg == "") || this.MechanicalDesignEnggArray.length > 1){
                  if(subSaleOrder.enggDrawIP.mechanicalDesignEngineerId != null && subSaleOrder.enggDrawIP.mechanicalDesignEngineerId != ""){
  
                    //Check for C40 date actual and C50 date is missing
                    // C50 --- Actual C50- Actual C40
      
                    // if ((subSaleOrder.enggProcureIP.actualC50Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC50Date.getFullYear())&& (subSaleOrder.enggProcureIP.actualC40Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear() )) {
                    if ((subSaleOrder.enggProcureIP.actualC50Date != null && selYear.getFullYear() == subSaleOrder.enggProcureIP.actualC50Date.getFullYear())&& (subSaleOrder.enggProcureIP.actualC40Date != null)) {
                      _tmpc50Counter++;
                      let _actualC50Date = subSaleOrder.enggProcureIP.actualC50Date.getTime();
                      let _actualC40Date = subSaleOrder.enggProcureIP.actualC40Date.getTime();
                      let diffDatesC50AndC40 = (_actualC50Date - _actualC40Date);
                      let _C50AndC40Diff_time = diffDatesC50AndC40 / (1000 * 3600 * 24);
                      let _C40AndC50Diff = _C50AndC40Diff_time;
                      _c50Mech +=_C40AndC50Diff;
                    }
                  }
                //}
               
            }
          });
        }
      }
    }
  }
  else{

    this._soObjList2.filter((_tmpSO:SalesOrder) => {
      //test the filter.
      // if(_tmpSO.projectStatus == SOStatus.Dispatched || _tmpSO.projectStatus == SOStatus.Archived)
      if(_tmpSO.projectStatus == SOStatus.Dispatched)
      {
        return false;
      }
      return true;
    });

    for (var i = 0; i < this._soObjList2.length; i++) {
      let _tmpSO: SalesOrder = this._soObjList2[i];

      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        let _filteredSSO: Array<SubSalesOrder> = [];
       
        _filteredSSO = this.getFilteredSubOrdersC301(_tmpSO.subSalesOrder);
        //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

          _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
            let equipmentFlagArray:boolean[] = [];
          
            subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                equipmentFlagArray.push(true);
              }else{
                equipmentFlagArray.push(false);
              }
            });

            if(equipmentFlagArray.includes(true)){
                // let currentYear:Date = new Date();
                if(this.MechDesignEngg == "" || this.MechanicalDesignEnggArray.includes("001")){
                  if(subSaleOrder.enggDrawIP.c30EngineerId != null && subSaleOrder.enggDrawIP.c30EngineerId != "" && subSaleOrder.enggDrawIP.c30EngineerId != "NaN"){
                    // Check for C40 date actual and GA date is missing  
                    // GA & Cross section // (Actual SLD- Actual HOM)+ 1
                    // if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null && currentYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() )) {
                    // if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null)) {
                      if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null )&& (_tmpSO.marketingIP.actualHandingOverDate != null)) {
                      _tmpgaAndCrossSectionCounter++;
                      let _actualSLDGASubmission = subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getTime();
                      let _actualHandingOverDate = _tmpSO.marketingIP.actualHandingOverDate.getTime();
                      let diffDates = (_actualSLDGASubmission - _actualHandingOverDate);
                      let _gaAndCrossSecDiff_time = diffDates / (1000 * 3600 * 24);
                      let _gaAndCrossSecDiff = _gaAndCrossSecDiff_time + 1;
                      _gaAndCrossSectionMech +=_gaAndCrossSecDiff;
                    }
                  }
                }
                
            }
          });
        }
      }
    }

    for (var i = 0; i < this._soObjList2.length; i++) {
      let _tmpSOM: SalesOrder = this._soObjList2[i];

      let _isSOPassedFilterM: boolean = true;
      if (_isSOPassedFilterM == true) {
        
        let _filteredSSOM: Array<SubSalesOrder> = [];
        
        _filteredSSOM = this.getFilteredSubOrdersMech1(_tmpSOM.subSalesOrder);
        if (_filteredSSOM.length > 0 || (_tmpSOM.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

          _filteredSSOM.forEach((subSaleOrder: SubSalesOrder) => {
            let equipmentFlagArrayM:boolean[] = [];
          
            subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                equipmentFlagArrayM.push(true);
              }else{
                equipmentFlagArrayM.push(false);
              }
            });

            if(equipmentFlagArrayM.includes(true)){
                // let currentYear:Date = new Date();
                
                //if((this.MechanicalDesignEnggArray.length == 1 && this.MechDesignEngg != "001") || (this.MechDesignEngg == "") || this.MechanicalDesignEnggArray.length > 1){
                  if(subSaleOrder.enggDrawIP.mechanicalDesignEngineerId != null && subSaleOrder.enggDrawIP.mechanicalDesignEngineerId != ""){
  
                    //Check for C40 date actual and C50 date is missing
                    // C50 --- Actual C50- Actual C40
      
                    // if ((subSaleOrder.enggProcureIP.actualC50Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC50Date.getFullYear())&& (subSaleOrder.enggProcureIP.actualC40Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear() )) {
                    // if ((subSaleOrder.enggProcureIP.actualC50Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC50Date.getFullYear())&& (subSaleOrder.enggProcureIP.actualC40Date != null)) {
                      if ((subSaleOrder.enggProcureIP.actualC50Date != null )&& (subSaleOrder.enggProcureIP.actualC40Date != null)) {
                      _tmpc50Counter++;
                      let _actualC50Date = subSaleOrder.enggProcureIP.actualC50Date.getTime();
                      let _actualC40Date = subSaleOrder.enggProcureIP.actualC40Date.getTime();
                      let diffDatesC50AndC40 = (_actualC50Date - _actualC40Date);
                      let _C50AndC40Diff_time = diffDatesC50AndC40 / (1000 * 3600 * 24);
                      let _C40AndC50Diff = _C50AndC40Diff_time;
                      _c50Mech +=_C40AndC50Diff;
                    }
                  }
                //}
               
            }
          });
        }
      }
    }
  }  
  if(_gaAndCrossSectionMech!=0 ||_tmpgaAndCrossSectionCounter!=0 || _c50Mech!=0 || _tmpc50Counter!=0){
    this.totalDataMDE = [{
      "data": [{
        name: 'GA & Cross section',
        color: '#6e6e6e',
        y: Math.round(_gaAndCrossSectionMech/_tmpgaAndCrossSectionCounter),
      },
      {
        name: 'C50',
        color: '#6e6e6e',
        y: Math.round(_c50Mech/_tmpc50Counter),
      }]
    }

    ];
  }
  else{ this.totalDataMDE = null;}
  
  this.totalDataMDEKpiChartOptionsSO = this._kpiCharServ.getTotalDataChartOptions(this.totalDataMDE);

  this.isDataViewUpdated = true;
  setTimeout(() => {
    this.isDataViewUpdated = false;
  }, 1000);
  }

  filterRowsLogic4(){
    let _drawingApprovalPe:number= 0;
 
    let _tmpdrawingApprovalCounter: number = 0;

    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    let _showSOWithNoSSO: boolean = true;

    if(this.isYearFilterSelectedPE==true){
    for (var i = 0; i < this._soObjList2.length; i++) {
      let _tmpSO: SalesOrder = this._soObjList2[i];
      if(_tmpSO.pmCommercial.projectEngineerId != null && _tmpSO.pmCommercial.projectEngineerId != ""){

      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        //filters need to be added for user
        let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrdersPE(_tmpSO.subSalesOrder);
        //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

          _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
            let equipmentFlagArray:boolean[] = [];
          
            subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                equipmentFlagArray.push(true);
              }else{
                equipmentFlagArray.push(false);
              }
            });

            if(equipmentFlagArray.includes(true)){
                // let currentYear:Date = new Date();
                let selYear:Date = new Date(this.yearFilterPE.selYear,1,1);

                // Check for C40 date actual and GA date is missing 
              // Drawing approval // (Actual drawing approval- Actual HOM)+1
              // if ((subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate != null && currentYear.getFullYear() == subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null && currentYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() )) {
              if ((subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate != null && selYear.getFullYear() == subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null)) {
                _tmpdrawingApprovalCounter++;
                let _actualDrawingApprovalDate = subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate.getTime();
                let _actualHandingOverDate = _tmpSO.marketingIP.actualHandingOverDate.getTime();
                let diffDates = (_actualDrawingApprovalDate - _actualHandingOverDate);
                let _actualDrawingDiff_time = diffDates / (1000 * 3600 * 24);
                let _actualDrawingDiff = _actualDrawingDiff_time + 1;
                _drawingApprovalPe +=_actualDrawingDiff;
              }
               
            }
          });
        }
      }
    }
  }
}
else {
  this._soObjList2.filter((_tmpSO:SalesOrder) => {
    //test the filter.
    // if(_tmpSO.projectStatus == SOStatus.Dispatched || _tmpSO.projectStatus == SOStatus.Archived)
    if(_tmpSO.projectStatus == SOStatus.Dispatched)
    {
      return false;
    }
    return true;
  });
  for (var i = 0; i < this._soObjList2.length; i++) {
    let _tmpSO: SalesOrder = this._soObjList2[i];
    if(_tmpSO.pmCommercial.projectEngineerId != null && _tmpSO.pmCommercial.projectEngineerId != ""){

    let _isSOPassedFilter: boolean = true;
    if (_isSOPassedFilter == true) {
      //filters need to be added for user
      let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrdersPE1(_tmpSO.subSalesOrder);
      //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;

      if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

        _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
          let equipmentFlagArray:boolean[] = [];
        
          subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
            if (_equpList.includes(e.equipmentType)) {
              equipmentFlagArray.push(true);
            }else{
              equipmentFlagArray.push(false);
            }
          });

          if(equipmentFlagArray.includes(true)){

              // Check for C40 date actual and GA date is missing 
            // Drawing approval // (Actual drawing approval- Actual HOM)+1
            // if ((subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate != null && currentYear.getFullYear() == subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null && currentYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() )) {
            if ((subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate != null)&& (_tmpSO.marketingIP.actualHandingOverDate != null)) {
              _tmpdrawingApprovalCounter++;
              let _actualDrawingApprovalDate = subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate.getTime();
              let _actualHandingOverDate = _tmpSO.marketingIP.actualHandingOverDate.getTime();
              let diffDates = (_actualDrawingApprovalDate - _actualHandingOverDate);
              let _actualDrawingDiff_time = diffDates / (1000 * 3600 * 24);
              let _actualDrawingDiff = _actualDrawingDiff_time + 1;
              _drawingApprovalPe +=_actualDrawingDiff;
            }
             
          }
        });
      }
    }
  }
}
}

if(_drawingApprovalPe!=0 && _tmpdrawingApprovalCounter!=0){
    this.totalDataPE = [{
      "data": [{
        name: 'Drawing approval',
        color: '#6e6e6e',
        y: Math.round(_drawingApprovalPe/_tmpdrawingApprovalCounter),
      }]
    }

    ];
  }
  else { this.totalDataPE = null };

  this.totalDataPEKpiChartOptionsSO = this._kpiCharServ.getTotalDataChartOptions(this.totalDataPE);

  this.isDataViewUpdated = true;
  setTimeout(() => {
    this.isDataViewUpdated = false;
  }, 1000);
  }

  loadEDEData(){
    this.isLoading2 = true;
    let ElecDesignEngineers = this._dataService.electricalDesignEngineer;
    
    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    if(this.isYearFilterSelectedEDE==true){ 
      this.ElectricalDesignEngineerKPIArray =[];
    ElecDesignEngineers.forEach((ele:ElectricalDesignEngineer) => {
      let _sldCsEle:number= 0;
      let _schemeAndOtherDrgsEle:number=0;
      let _sldGaCsEle:number=0;
      let _C40Ele:number=0;
      let _C60Ele:number=0;
  
      let _tmpSldCounter: number = 0;
      let _tmpSchematicCounter: number = 0;
      let _tmpSldGaCounter: number = 0;
      let _tmpC40Counter: number = 0;
      let _tmpC60Counter: number = 0;

      let _finalSldCsValue:number = 0;
      let _finalSchemesAndOtherValue:number = 0;
      let _finalSldGaCsValue:number = 0;
      let _finalC40Value:number = 0;
      let _finalC60Value:number = 0;

      let _showSOWithNoSSO: boolean = true;
      for (var i = 0; i < this._soObjList2.length; i++) {
        let _tmpSO: SalesOrder = this._soObjList2[i];
  
        let _isSOPassedFilter: boolean = true;
        if (_isSOPassedFilter == true) {
          //filters need to be added for user
          let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
          //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;

          if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
  
            _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
              let equipmentFlagArray:boolean[] = [];
            
              subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                
                if (_equpList.includes(e.equipmentType)) {
                  equipmentFlagArray.push(true);
                }else{
                  equipmentFlagArray.push(false);
                }
              });
              
              if(equipmentFlagArray.includes(true)){
                
               // _filteredSSO.forEach((subSaleOrder:SubSalesOrder) => {
                  if(subSaleOrder.enggDrawIP.electricalDesignEngineerId == ele.electricalDesignEngineerId){
                    // let currentYear:Date = new Date();
                    let selYear:Date = new Date(this.yearFilterEDE.selYear,1,1);

              // Check for C40 date and SLD date is missing   
              // SLD CS (1st subm) (Actual SLD- Actual HOM)+ 1
              // if ((subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null && currentYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() )) {
              if ((subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null && selYear.getFullYear() == subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null)) {
                _tmpSldCounter++;
                let _actualSLDSubmission = subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getTime();
                let _actualHandingOverDate = _tmpSO.marketingIP.actualHandingOverDate.getTime();
                let diffDates = (_actualSLDSubmission - _actualHandingOverDate);
                let _sldDiff_time = diffDates / (1000 * 3600 * 24);
                let _sldDiff = _sldDiff_time + 1;
                _sldCsEle +=_sldDiff;
              }

              // Check for C40 date and Scheme date is missing
              // Schemes & other drgs  (Actual Schem- Actual HOM)+ 1

              // if ((subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null && currentYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() )) {
              if ((subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual != null && selYear.getFullYear() == subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null)) {
                _tmpSchematicCounter++;
                let _actualSchematicBOMSubmission = subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual.getTime();
                let _actualHandingOverDate = _tmpSO.marketingIP.actualHandingOverDate.getTime();
                let diffDatesSchematicAndOtherDrgs = (_actualSchematicBOMSubmission - _actualHandingOverDate);
                let _schematicDiff_time = diffDatesSchematicAndOtherDrgs / (1000 * 3600 * 24);
                let _schematicDiff = _schematicDiff_time + 1;
                _schemeAndOtherDrgsEle +=_schematicDiff;
              }

              // Check for C40 date and Approval date is missing
              // Approval (SLD+GA+CS) (Actual SLD & GA approval- Actual SLD)+ 1

              // if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )&& (subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getFullYear() )) {
              if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && selYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )&& (subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null)) {
                _tmpSldGaCounter++;
                let _actualSLDGAApprovalDate = subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getTime();
                let _initialSLDSubmissionDateActual = subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getTime();
                let diffDatesSLDAndGA = (_actualSLDGAApprovalDate - _initialSLDSubmissionDateActual);
                let _SldAndGaDiff_time = diffDatesSLDAndGA / (1000 * 3600 * 24);
                let _SldAndGaDiff = _SldAndGaDiff_time + 1;
                _sldGaCsEle +=_SldAndGaDiff;
              }

              // Check for actual line loading and C40 date actual missing
              // C40 --- Actual C40- Actual SLD & GA approval

              // if ((subSaleOrder.enggProcureIP.actualC40Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear() )&& (subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )) {
              if ((subSaleOrder.enggProcureIP.actualC40Date != null && selYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear() )&& (subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null)) {
                _tmpC40Counter++;
                let _actualC40Date = subSaleOrder.enggProcureIP.actualC40Date.getTime();
                let _actualSLDGAApprovalDate = subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getTime();
                let diffDatesC40AndSLDAndGA = (_actualC40Date - _actualSLDGAApprovalDate);
                let _C40SldAndGaDiff_time = diffDatesC40AndSLDAndGA / (1000 * 3600 * 24);
                let _C40SldAndGaDiff = _C40SldAndGaDiff_time + 1;
                _C40Ele +=_C40SldAndGaDiff;
              }

              // Check for actual line loading and C60 date actual missing
              // C60 --- Actual C60- Actual C40

              // if ((subSaleOrder.enggProcureIP.actualC60Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC60Date.getFullYear()) && (subSaleOrder.enggProcureIP.actualC40Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear() )) {
              if ((subSaleOrder.enggProcureIP.actualC60Date != null && selYear.getFullYear() == subSaleOrder.enggProcureIP.actualC60Date.getFullYear()) && (subSaleOrder.enggProcureIP.actualC40Date != null)) {
                _tmpC60Counter++;
                let _actualC60Date = subSaleOrder.enggProcureIP.actualC60Date.getTime();
                let _actualC40Date = subSaleOrder.enggProcureIP.actualC40Date.getTime();
                let diffDatesC60AndC40 = (_actualC60Date - _actualC40Date);
                let _C60AndC40Diff_time = diffDatesC60AndC40 / (1000 * 3600 * 24);
                let _C40AndC60Diff = _C60AndC40Diff_time + 1;
                _C60Ele +=_C40AndC60Diff;
              }
              }
                  
                //});
              }
            });
          }
        }
      }

      //Check NaN
      if(_tmpSldCounter != 0){
        _finalSldCsValue = Math.round(_sldCsEle/_tmpSldCounter);
      }

      if(_tmpSchematicCounter != 0){
        _finalSchemesAndOtherValue = Math.round(_schemeAndOtherDrgsEle/_tmpSchematicCounter);
      }

      if(_tmpSldGaCounter != 0){
        _finalSldGaCsValue = Math.round(_sldGaCsEle/_tmpSldGaCounter);
      }

      if(_tmpC40Counter != 0){
        _finalC40Value = Math.round(_C40Ele/_tmpC40Counter);
      }

      if(_tmpC60Counter != 0){
        _finalC60Value = Math.round(_C60Ele/_tmpC60Counter);
      }
      
      this.ElectricalDesignEngineerKPIArray.push(new ElectricalDesignEngineerKPI(ele.electricalDesignEngineerName,_finalSldCsValue,_finalSchemesAndOtherValue,_finalSldGaCsValue,_finalC40Value,_finalC60Value));
      
    });
    }
    else{
      this._soObjList2.filter((_tmpSO:SalesOrder) => {
        //test the filter.
        // if(_tmpSO.projectStatus == SOStatus.Dispatched || _tmpSO.projectStatus == SOStatus.Archived)
        if(_tmpSO.projectStatus == SOStatus.Dispatched)
        {
          return false;
        }
        return true;
      });
    
    this.ElectricalDesignEngineerKPIArray=[];
      ElecDesignEngineers.forEach((ele:ElectricalDesignEngineer) => {
        let _sldCsEle:number= 0;
        let _schemeAndOtherDrgsEle:number=0;
        let _sldGaCsEle:number=0;
        let _C40Ele:number=0;
        let _C60Ele:number=0;
    
        let _tmpSldCounter: number = 0;
        let _tmpSchematicCounter: number = 0;
        let _tmpSldGaCounter: number = 0;
        let _tmpC40Counter: number = 0;
        let _tmpC60Counter: number = 0;
  
        let _finalSldCsValue:number = 0;
        let _finalSchemesAndOtherValue:number = 0;
        let _finalSldGaCsValue:number = 0;
        let _finalC40Value:number = 0;
        let _finalC60Value:number = 0;
  
        let _showSOWithNoSSO: boolean = true;
        for (var i = 0; i < this._soObjList2.length; i++) {
          let _tmpSO: SalesOrder = this._soObjList2[i];
    
          let _isSOPassedFilter: boolean = true;
          if (_isSOPassedFilter == true) {
            //filters need to be added for user
            let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
            //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
  
            if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
    
              _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
                if (subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true) {
                let equipmentFlagArray:boolean[] = [];
              
                subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  
                  if (_equpList.includes(e.equipmentType)) {
                    equipmentFlagArray.push(true);
                  }else{
                    equipmentFlagArray.push(false);
                  }
                });
                
                if(equipmentFlagArray.includes(true)){
                  
                 // _filteredSSO.forEach((subSaleOrder:SubSalesOrder) => {
                    if(subSaleOrder.enggDrawIP.electricalDesignEngineerId == ele.electricalDesignEngineerId){
                      // let currentYear:Date = new Date();
  
                // Check for C40 date and SLD date is missing   
                // SLD CS (1st subm) (Actual SLD- Actual HOM)+ 1
                // if ((subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null && currentYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() )) {
                // if ((subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null)) {
                  if ((subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null )&& (_tmpSO.marketingIP.actualHandingOverDate != null)) {
                  _tmpSldCounter++;
                  let _actualSLDSubmission = subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getTime();
                  let _actualHandingOverDate = _tmpSO.marketingIP.actualHandingOverDate.getTime();
                  let diffDates = (_actualSLDSubmission - _actualHandingOverDate);
                  let _sldDiff_time = diffDates / (1000 * 3600 * 24);
                  let _sldDiff = _sldDiff_time + 1;
                  _sldCsEle +=_sldDiff;
                }
  
                // Check for C40 date and Scheme date is missing
                // Schemes & other drgs  (Actual Schem- Actual HOM)+ 1
  
                // if ((subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null && currentYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() )) {
                // if ((subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null)) {
                  if ((subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual != null)&& (_tmpSO.marketingIP.actualHandingOverDate != null)) {
                  _tmpSchematicCounter++;
                  let _actualSchematicBOMSubmission = subSaleOrder.enggDrawIP.initialSchematicDBOMSubmissionDateActual.getTime();
                  let _actualHandingOverDate = _tmpSO.marketingIP.actualHandingOverDate.getTime();
                  let diffDatesSchematicAndOtherDrgs = (_actualSchematicBOMSubmission - _actualHandingOverDate);
                  let _schematicDiff_time = diffDatesSchematicAndOtherDrgs / (1000 * 3600 * 24);
                  let _schematicDiff = _schematicDiff_time + 1;
                  _schemeAndOtherDrgsEle +=_schematicDiff;
                }
  
                // Check for C40 date and Approval date is missing
                // Approval (SLD+GA+CS) (Actual SLD & GA approval- Actual SLD)+ 1
  
                // if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )&& (subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getFullYear() )) {
                // if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )&& (subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null)) {
                  if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null )&& (subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual != null)) {
                  _tmpSldGaCounter++;
                  let _actualSLDGAApprovalDate = subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getTime();
                  let _initialSLDSubmissionDateActual = subSaleOrder.enggDrawIP.initialSLDSubmissionDateActual.getTime();
                  let diffDatesSLDAndGA = (_actualSLDGAApprovalDate - _initialSLDSubmissionDateActual);
                  let _SldAndGaDiff_time = diffDatesSLDAndGA / (1000 * 3600 * 24);
                  let _SldAndGaDiff = _SldAndGaDiff_time + 1;
                  _sldGaCsEle +=_SldAndGaDiff;
                }
  
                // Check for actual line loading and C40 date actual missing
                // C40 --- Actual C40- Actual SLD & GA approval
  
                // if ((subSaleOrder.enggProcureIP.actualC40Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear() )&& (subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )) {
                // if ((subSaleOrder.enggProcureIP.actualC40Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear() )&& (subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null)) {
                  if ((subSaleOrder.enggProcureIP.actualC40Date != null )&& (subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null)) {
                  _tmpC40Counter++;
                  let _actualC40Date = subSaleOrder.enggProcureIP.actualC40Date.getTime();
                  let _actualSLDGAApprovalDate = subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getTime();
                  let diffDatesC40AndSLDAndGA = (_actualC40Date - _actualSLDGAApprovalDate);
                  let _C40SldAndGaDiff_time = diffDatesC40AndSLDAndGA / (1000 * 3600 * 24);
                  let _C40SldAndGaDiff = _C40SldAndGaDiff_time + 1;
                  _C40Ele +=_C40SldAndGaDiff;
                }
  
                // Check for actual line loading and C60 date actual missing
                // C60 --- Actual C60- Actual C40
  
                // if ((subSaleOrder.enggProcureIP.actualC60Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC60Date.getFullYear()) && (subSaleOrder.enggProcureIP.actualC40Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear() )) {
                // if ((subSaleOrder.enggProcureIP.actualC60Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC60Date.getFullYear()) && (subSaleOrder.enggProcureIP.actualC40Date != null)) {
                  if ((subSaleOrder.enggProcureIP.actualC60Date != null ) && (subSaleOrder.enggProcureIP.actualC40Date != null)) {
                  _tmpC60Counter++;
                  let _actualC60Date = subSaleOrder.enggProcureIP.actualC60Date.getTime();
                  let _actualC40Date = subSaleOrder.enggProcureIP.actualC40Date.getTime();
                  let diffDatesC60AndC40 = (_actualC60Date - _actualC40Date);
                  let _C60AndC40Diff_time = diffDatesC60AndC40 / (1000 * 3600 * 24);
                  let _C40AndC60Diff = _C60AndC40Diff_time + 1;
                  _C60Ele +=_C40AndC60Diff;
                }
                }
                    
                  //});
                }
              }
              });
            }
          }
        }
  
        //Check NaN
        if(_tmpSldCounter != 0){
          _finalSldCsValue = Math.round(_sldCsEle/_tmpSldCounter);
        }
  
        if(_tmpSchematicCounter != 0){
          _finalSchemesAndOtherValue = Math.round(_schemeAndOtherDrgsEle/_tmpSchematicCounter);
        }
  
        if(_tmpSldGaCounter != 0){
          _finalSldGaCsValue = Math.round(_sldGaCsEle/_tmpSldGaCounter);
        }
  
        if(_tmpC40Counter != 0){
          _finalC40Value = Math.round(_C40Ele/_tmpC40Counter);
        }
  
        if(_tmpC60Counter != 0){
          _finalC60Value = Math.round(_C60Ele/_tmpC60Counter);
        }
        
        this.ElectricalDesignEngineerKPIArray.push(new ElectricalDesignEngineerKPI(ele.electricalDesignEngineerName,_finalSldCsValue,_finalSchemesAndOtherValue,_finalSldGaCsValue,_finalC40Value,_finalC60Value));
        
      });
    }
this.isLoading2 = false;
  }

  loadMDEData(){
    this.isLoading2 = true;
    
    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];
    if(this.isYearFilterSelectedMDE==true){ 
      this.MechanicalDesignEngineerKPIArray =[];
    this.MechanicalEngineers.forEach((mech:any) => {
      let _gaAndCrossSectionMech:number= 0;
      let _c50Mech:number=0;
   
      let _tmpgaAndCrossSectionCounter: number = 0;
      let _tmpc50Counter: number = 0;

      let _finalgaAndCrossSectionMechValue:number = 0;
      let _finalc50MechValue:number = 0;

      let _showSOWithNoSSO: boolean = true;
      for (var i = 0; i < this._soObjList2.length; i++) {
        let _tmpSO: SalesOrder = this._soObjList2[i];
  
        let _isSOPassedFilter: boolean = true;
        if (_isSOPassedFilter == true) {
          //filters need to be added for user
          let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
          //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;

          if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
  
            _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
              let equipmentFlagArray:boolean[] = [];
            
              subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                
                if (_equpList.includes(e.equipmentType)) {
                  equipmentFlagArray.push(true);
                }else{
                  equipmentFlagArray.push(false);
                }
              });
              
              if(equipmentFlagArray.includes(true)){
                
                if(subSaleOrder.enggDrawIP.c30EngineerId == mech.id){
                  // let currentYear:Date = new Date();
                  let selYear:Date = new Date(this.yearFilterMDE.selYear,1,1);
                  // Check for C40 date actual and GA date is missing  
                  // GA & Cross section // (Actual SLD- Actual HOM)+ 1
                  // if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null && currentYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() )) {
                  if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && selYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null)) {
                    _tmpgaAndCrossSectionCounter++;
                    let _actualSLDSubmission = subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getTime();
                    let _actualHandingOverDate = _tmpSO.marketingIP.actualHandingOverDate.getTime();
                    let diffDates = (_actualSLDSubmission - _actualHandingOverDate);
                    let _gaAndCrossSecDiff_time = diffDates / (1000 * 3600 * 24);
                    let _gaAndCrossSecDiff = _gaAndCrossSecDiff_time + 1;
                    _gaAndCrossSectionMech +=_gaAndCrossSecDiff;
                  }
                }
               // _filteredSSO.forEach((subSaleOrder:SubSalesOrder) => {
                  if(mech.id != "001" && subSaleOrder.enggDrawIP.mechanicalDesignEngineerId == mech.id){
                    // let currentYear:Date = new Date();
                    let selYear:Date = new Date(this.yearFilterMDE.selYear,1,1);

                    // Check for actual line loading and C60 date actual missing
                    // C60 --- Actual C60- Actual C40
                    // if ((subSaleOrder.enggProcureIP.actualC50Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC50Date.getFullYear())&& (subSaleOrder.enggProcureIP.actualC40Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear() )) {
                    if ((subSaleOrder.enggProcureIP.actualC50Date != null && selYear.getFullYear() == subSaleOrder.enggProcureIP.actualC50Date.getFullYear())&& (subSaleOrder.enggProcureIP.actualC40Date != null)) {
                      _tmpc50Counter++;
                      let _actualC50Date = subSaleOrder.enggProcureIP.actualC50Date.getTime();
                      let _actualC40Date = subSaleOrder.enggProcureIP.actualC40Date.getTime();
                      let diffDatesC50AndC40 = (_actualC50Date - _actualC40Date);
                      let _C50AndC40Diff_time = diffDatesC50AndC40 / (1000 * 3600 * 24);
                      let _C40AndC50Diff = _C50AndC40Diff_time;
                      _c50Mech +=_C40AndC50Diff;
                    }
              }
              
              }
            });
          }
        }
      }

      //Check NaN
      if(_tmpgaAndCrossSectionCounter != 0){
        _finalgaAndCrossSectionMechValue = Math.round(_gaAndCrossSectionMech/_tmpgaAndCrossSectionCounter);
      }

      if(_tmpc50Counter != 0){
        _finalc50MechValue = Math.round(_c50Mech/_tmpc50Counter);
      }
      this.MechanicalDesignEngineerKPIArray.push(new MechanicalDesignEngineerKPI(mech.name,_finalgaAndCrossSectionMechValue,_finalc50MechValue));
      
    });
  }
  else{
    this._soObjList2.filter((_tmpSO:SalesOrder) => {
      //test the filter.
      // if(_tmpSO.projectStatus == SOStatus.Dispatched || _tmpSO.projectStatus == SOStatus.Archived)
      if(_tmpSO.projectStatus == SOStatus.Dispatched)
      {
        return false;
      }
      return true;
    });
  
  this.MechanicalDesignEngineerKPIArray=[];
    this.MechanicalEngineers.forEach((mech:any) => {
      let _gaAndCrossSectionMech:number= 0;
      let _c50Mech:number=0;
   
      let _tmpgaAndCrossSectionCounter: number = 0;
      let _tmpc50Counter: number = 0;

      let _finalgaAndCrossSectionMechValue:number = 0;
      let _finalc50MechValue:number = 0;

      let _showSOWithNoSSO: boolean = true;
      for (var i = 0; i < this._soObjList2.length; i++) {
        let _tmpSO: SalesOrder = this._soObjList2[i];
  
        let _isSOPassedFilter: boolean = true;
        if (_isSOPassedFilter == true) {
          //filters need to be added for user
          let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
          //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;

          if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
  
            _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
              if (subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true) {
              let equipmentFlagArray:boolean[] = [];
            
              subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                
                if (_equpList.includes(e.equipmentType)) {
                  equipmentFlagArray.push(true);
                }else{
                  equipmentFlagArray.push(false);
                }
              });
              
              if(equipmentFlagArray.includes(true)){
                
                if(subSaleOrder.enggDrawIP.c30EngineerId == mech.id){
                  // let currentYear:Date = new Date();
                  // Check for C40 date actual and GA date is missing  
                  // GA & Cross section // (Actual SLD- Actual HOM)+ 1
                  // if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null && currentYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() )) {
                  // if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null && currentYear.getFullYear() == subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null)) {
                    if ((subSaleOrder.enggDrawIP.actualSLDGAApprovalDate != null )&& (_tmpSO.marketingIP.actualHandingOverDate != null)) {
                    _tmpgaAndCrossSectionCounter++;
                    let _actualSLDSubmission = subSaleOrder.enggDrawIP.actualSLDGAApprovalDate.getTime();
                    let _actualHandingOverDate = _tmpSO.marketingIP.actualHandingOverDate.getTime();
                    let diffDates = (_actualSLDSubmission - _actualHandingOverDate);
                    let _gaAndCrossSecDiff_time = diffDates / (1000 * 3600 * 24);
                    let _gaAndCrossSecDiff = _gaAndCrossSecDiff_time + 1;
                    _gaAndCrossSectionMech +=_gaAndCrossSecDiff;
                  }
                }
               // _filteredSSO.forEach((subSaleOrder:SubSalesOrder) => {
                  if(mech.id != "001" && subSaleOrder.enggDrawIP.mechanicalDesignEngineerId == mech.id){
                    // let currentYear:Date = new Date();
                    // Check for actual line loading and C60 date actual missing
                    // C60 --- Actual C60- Actual C40
                    // if ((subSaleOrder.enggProcureIP.actualC50Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC50Date.getFullYear())&& (subSaleOrder.enggProcureIP.actualC40Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC40Date.getFullYear() )) {
                    // if ((subSaleOrder.enggProcureIP.actualC50Date != null && currentYear.getFullYear() == subSaleOrder.enggProcureIP.actualC50Date.getFullYear())&& (subSaleOrder.enggProcureIP.actualC40Date != null)) {
                      if ((subSaleOrder.enggProcureIP.actualC50Date != null)&& (subSaleOrder.enggProcureIP.actualC40Date != null)) {
                      _tmpc50Counter++;
                      let _actualC50Date = subSaleOrder.enggProcureIP.actualC50Date.getTime();
                      let _actualC40Date = subSaleOrder.enggProcureIP.actualC40Date.getTime();
                      let diffDatesC50AndC40 = (_actualC50Date - _actualC40Date);
                      let _C50AndC40Diff_time = diffDatesC50AndC40 / (1000 * 3600 * 24);
                      let _C40AndC50Diff = _C50AndC40Diff_time;
                      _c50Mech +=_C40AndC50Diff;
                    }
              }
              
              }
            }
            });
          }
        }
      }

      //Check NaN
      if(_tmpgaAndCrossSectionCounter != 0){
        _finalgaAndCrossSectionMechValue = Math.round(_gaAndCrossSectionMech/_tmpgaAndCrossSectionCounter);
      }

      if(_tmpc50Counter != 0){
        _finalc50MechValue = Math.round(_c50Mech/_tmpc50Counter);
      }

      this.MechanicalDesignEngineerKPIArray.push(new MechanicalDesignEngineerKPI(mech.name,_finalgaAndCrossSectionMechValue,_finalc50MechValue));
      
    });
  }
this.isLoading2 = false;
  }

  loadPEData(){
    this.isLoading2 = true;
    let ProjectEngineers = this._dataService.projectEngineers;
    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];
    if(this.isYearFilterSelectedPE==true){ 
      this.ProjectEngineerKPIArray =[];
    ProjectEngineers.forEach((pe:ProjectEngineer) => {
      let _drawingApprovalPe:number= 0;
 
    let _tmpdrawingApprovalCounter: number = 0;

    let _finalDrawingApprovalValue: number = 0;

    let _showSOWithNoSSO: boolean = true;

      for (var i = 0; i < this._soObjList2.length; i++) {
        
        let _tmpSO: SalesOrder = this._soObjList2[i];
  
        if(_tmpSO.pmCommercial.projectEngineerId != null && _tmpSO.pmCommercial.projectEngineerId != "" && _tmpSO.pmCommercial.projectEngineerId == pe.projectEngineerId){

          let _isSOPassedFilter: boolean = true;
          if (_isSOPassedFilter == true) {
            //filters need to be added for user
            let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
            //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
    
            if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
    
              _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
             
                let equipmentFlagArray:boolean[] = [];
              
                subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    equipmentFlagArray.push(true);
                  }else{
                    equipmentFlagArray.push(false);
                  }
                });
    
                if(equipmentFlagArray.includes(true)){
                    // let currentYear:Date = new Date();
                    let selYear:Date = new Date(this.yearFilterPE.selYear,1,1);
    
                    // Check for C40 date actual and GA date is missing 
                  // Drawing approval // (Actual drawing approval- Actual HOM)+1
                  // if ((subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate != null && currentYear.getFullYear() == subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null && currentYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() )) {
                  if ((subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate != null && selYear.getFullYear() == subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null)) {
                    _tmpdrawingApprovalCounter++;
                    let _actualDrawingApprovalDate = subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate.getTime();
                    let _actualHandingOverDate = _tmpSO.marketingIP.actualHandingOverDate.getTime();
                    let diffDates = (_actualDrawingApprovalDate - _actualHandingOverDate);
                    let _actualDrawingDiff_time = diffDates / (1000 * 3600 * 24);
                    let _actualDrawingDiff = _actualDrawingDiff_time + 1;
                    _drawingApprovalPe +=_actualDrawingDiff;
                  }
                   
                }
              });
            }
          }
        }
      }

      //Check NaN
      if(_tmpdrawingApprovalCounter != 0){
        _finalDrawingApprovalValue = Math.round(_drawingApprovalPe/_tmpdrawingApprovalCounter);
      }

      this.ProjectEngineerKPIArray.push(new ProjectEngineerKPI(pe.projectEngineerName,_finalDrawingApprovalValue));
      
    });
  }
  else{
    
    this._soObjList2.filter((_tmpSO:SalesOrder) => {
      //test the filter.
      // if(_tmpSO.projectStatus == SOStatus.Dispatched || _tmpSO.projectStatus == SOStatus.Archived)
      if(_tmpSO.projectStatus == SOStatus.Dispatched)
      {
        return false;
      }
      return true;
    });
  
  this.ProjectEngineerKPIArray=[];
    ProjectEngineers.forEach((pe:ProjectEngineer) => {
      let _drawingApprovalPe:number= 0;
 
    let _tmpdrawingApprovalCounter: number = 0;

    let _finalDrawingApprovalValue: number = 0;

    let _showSOWithNoSSO: boolean = true;

      for (var i = 0; i < this._soObjList2.length; i++) {
        let _tmpSO: SalesOrder = this._soObjList2[i];
  
        if(_tmpSO.pmCommercial.projectEngineerId != null && _tmpSO.pmCommercial.projectEngineerId != "" && _tmpSO.pmCommercial.projectEngineerId == pe.projectEngineerId){

          let _isSOPassedFilter: boolean = true;
          if (_isSOPassedFilter == true) {
            //filters need to be added for user
            let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
            //let _filteredSSO: Array<SubSalesOrder> = _tmpSO.subSalesOrder;
    
            if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {
    
              _filteredSSO.forEach((subSaleOrder: SubSalesOrder) => {
                if (subSaleOrder.isSSOStatusSet(SSOStatus.Dispatched) != true) {
                let equipmentFlagArray:boolean[] = [];
              
                subSaleOrder.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    equipmentFlagArray.push(true);
                  }else{
                    equipmentFlagArray.push(false);
                  }
                });
    
                if(equipmentFlagArray.includes(true)){
                    // let currentYear:Date = new Date();
                    // let selYear:Date = new Date(this.yearFilter.selYear,1,1);
    
                    // Check for C40 date actual and GA date is missing 
                  // Drawing approval // (Actual drawing approval- Actual HOM)+1
                  // if ((subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate != null && currentYear.getFullYear() == subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null && currentYear.getFullYear() ==_tmpSO.marketingIP.actualHandingOverDate.getFullYear() )) {
                  // if ((subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate != null && selYear.getFullYear() == subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate.getFullYear() )&& (_tmpSO.marketingIP.actualHandingOverDate != null)) {
                    if ((subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate != null)&& (_tmpSO.marketingIP.actualHandingOverDate != null)) {
                    _tmpdrawingApprovalCounter++;
                    let _actualDrawingApprovalDate = subSaleOrder.pmTechSubSalesOrder.actualDrawingApprovalDate.getTime();
                    let _actualHandingOverDate = _tmpSO.marketingIP.actualHandingOverDate.getTime();
                    let diffDates = (_actualDrawingApprovalDate - _actualHandingOverDate);
                    let _actualDrawingDiff_time = diffDates / (1000 * 3600 * 24);
                    let _actualDrawingDiff = _actualDrawingDiff_time + 1;
                    _drawingApprovalPe +=_actualDrawingDiff;
                  }
                   
                }
              }
              });
            }
          }
        }
      }

      //Check NaN
      if(_tmpdrawingApprovalCounter != 0){
        _finalDrawingApprovalValue = Math.round(_drawingApprovalPe/_tmpdrawingApprovalCounter);
      }

      this.ProjectEngineerKPIArray.push(new ProjectEngineerKPI(pe.projectEngineerName,_finalDrawingApprovalValue));
      
    });
  }
this.isLoading2 = false;
  }

  private getFilteredSubOrders(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      if(this.isSSOUserFilterPassed(_sso.enggDrawIP.electricalDesignEngineerId) == false) return false;
      return true;
    });
  }

  private getFilteredSubOrders1(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      if(this.isSSOUserFilterPassed(_sso.enggDrawIP.electricalDesignEngineerId) == false) return false;
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true)  return false;
      return true;
    });
  }

  private isSSOUserFilterPassed(_elecEngId:string):boolean{
    //check for failure cases
    if(this.isUserSelectionFilterSelected == true && this.userSelectionType != userFilterOption.All){
      if(this.userSelectionType == userFilterOption.ElectricDesignEngineer){
        if(!this.ElecDesignEnggArray.includes(_elecEngId)) return false;
      }
    }
    return true;
  }

  private getFilteredSubOrdersMechAndC30(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      if((this.isSSOMechUserFilterPassed(_sso.enggDrawIP.mechanicalDesignEngineerId) || this.isSSOC30UserFilterPassed(_sso.enggDrawIP.c30EngineerId))  == false) return false;
      return true;
    });
  }

  private getFilteredSubOrdersMech1(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      if(this.isSSOMechUserFilterPassed(_sso.enggDrawIP.mechanicalDesignEngineerId) == false) return false;
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true)  return false;
      return true;
    });
  }

  private getFilteredSubOrdersC301(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      if(this.isSSOC30UserFilterPassed(_sso.enggDrawIP.c30EngineerId) == false) return false;
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true)  return false;
      return true;
    });
  }

  private getFilteredSubOrdersMech(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      if(this.isSSOMechUserFilterPassed(_sso.enggDrawIP.mechanicalDesignEngineerId) == false) return false;
      return true;
    });
  }

  private getFilteredSubOrdersC30(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      if(this.isSSOC30UserFilterPassed(_sso.enggDrawIP.c30EngineerId) == false) return false;
      return true;
    });
  }

  private isSSOMechUserFilterPassed(_mechEngId:string):boolean{
    //check for failure cases
    if(this.isMechUserSelectionFilterSelected == true && this.userMechSelectionType != userFilterOption.All){
      if(this.userMechSelectionType == userFilterOption.MechanicalDesignEngineer){
        if(!this.MechanicalDesignEnggArray.includes(_mechEngId)) return false;
      }
    }
    
    return true;
  }

  private isSSOC30UserFilterPassed(_mechEngId:string):boolean{
    //check for failure cases
    if(this.isMechUserSelectionFilterSelected == true && this.userMechSelectionType != userFilterOption.All){
      if(this.userMechSelectionType == userFilterOption.MechanicalDesignEngineer){
        if(!this.MechanicalDesignEnggArray.includes(_mechEngId)) return false;
      }
    }
    
    return true;
  }

  private getFilteredSubOrdersPE(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      if(this.isSSOPEUserFilterPassed(_sso.parentSORef.pmCommercial.projectEngineerId) == false) return false;
      return true;
    });
  }
  private getFilteredSubOrdersPE1(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      if(this.isSSOPEUserFilterPassed(_sso.parentSORef.pmCommercial.projectEngineerId) == false) return false;
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true)  return false;
      return true;
    });
  }

  private isSSOPEUserFilterPassed(_peEngId:string):boolean{
    //check for failure cases
    if(this.isPEUserSelectionFilterSelected == true && this.userPESelectionType != userFilterOption.All){
      if(this.userPESelectionType == userFilterOption.ProjectEngineer){
        if(!this.ProjectEnggArray.includes(_peEngId)) return false;
      }
    }
    
    return true;
  }
  getYearNamePE():string{
    if(this.yearFilterPE){
      return this.yearFilterPE.yearName;
    }
    return '';
  }
  
  getYearLabelPE():string{
    if(this.isYearFilterSelectedPE == true){
      return "Year : ";
    }
    else{
      return "Enable Year Filter";
    }
  }
  prevYearPE(){
    this.yearFilterPE.prevYear();
    this.filterRowsPE();
  }
  nextYearPE(){
    this.yearFilterPE.nextYear();
    this.filterRowsPE();
  }

  // EDE
  getYearNameEDE():string{
    if(this.yearFilterEDE){
      return this.yearFilterEDE.yearName;
    }
    return '';
  }
  
  getYearLabelEDE():string{
    if(this.isYearFilterSelectedEDE == true){
      return "Year : ";
    }
    else{
      return "Enable Year Filter";
    }
  }
  prevYearEDE(){
    this.yearFilterEDE.prevYear();
    this.filterRows();
  }
  nextYearEDE(){
    this.yearFilterEDE.nextYear();
    this.filterRows();
  }

  // MDE
  getYearNameMDE():string{
    if(this.yearFilterMDE){
      return this.yearFilterMDE.yearName;
    }
    return '';
  }
  
  getYearLabelMDE():string{
    if(this.isYearFilterSelectedMDE == true){
      return "Year : ";
    }
    else{
      return "Enable Year Filter";
    }
  }
  prevYearMDE(){
    this.yearFilterMDE.prevYear();
    this.filterRowsMech();
  }
  nextYearMDE(){
    this.yearFilterMDE.nextYear();
    this.filterRowsMech();
  }
  exportElectricalExcel() {
    if(this.isYearFilterSelectedEDE){
    // this._dataService.downloadFile('elecEngg');
    this._dataService.downloadFileKPI('elecEngg',1,this.yearFilterEDE.selYear);
  }
  else{
    this._dataService.downloadFileKPI('elecEngg',0,0);
  }
  }
  
  exportMechanicalExcel() {
    if(this.isYearFilterSelectedMDE){
    // this._dataService.downloadFile('mechEngg');
    this._dataService.downloadFileKPI('mechEngg',1,this.yearFilterMDE.selYear);
  }
  else{
    this._dataService.downloadFileKPI('mechEngg',0,0);
  }
  }

  exportProjectExcel() {
    if(this.isYearFilterSelectedPE){
    // this._dataService.downloadFile('projEngg');
    this._dataService.downloadFileKPI('projEngg',1,this.yearFilterPE.selYear);
  }
  else{
    this._dataService.downloadFileKPI('projEngg',0,0);
  }
}
}
